import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {usePeringatanListModel} from "@/stores/models/peringatan-list-model";

export const usePeringatanListStore  = defineStore(
    'peringatanListStore',
    () => {
       
        const isLoading = ref(false);
        const selectedPegawai = ref(null);
        const dataSourcePeringatanList = ref(
            new DataSource({
                requireTotalCount: true,
                store: usePeringatanListModel().peringatanListCustomStore,
                filter: null,
            })
        );

        // const dataSourcePendidikanList = (additionalParams = null) => {
        //     // console.log('masuk dataSourcePendidikanList', additionalParams)
        //     return new DataSource({
        //       requireTotalCount: true,
        //       load: (loadOptions) => {
        //         // Handle load options and additionalParams separately
        //         return usePendidikanListModel().pendidikanListCustomStore.load([loadOptions, additionalParams]);
        //       }
        //     });
        // };

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourcePeringatanList.value.reload();
        };

        const initialized = ()=>{     
            dataSourcePeringatanList.value.reload();
        };

        return {
            dataSourcePeringatanList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state,
            selectedPegawai

        }
    }
);